import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {AppConfigService} from "@ui-kit/framework/config/app-config.service";
import {UpdatePasswordContextModel} from "@ui-kit/framework/security/model/update-password-context.model";
import {UPDATE_PASSWORD_OTP_TYPE} from "@ui-kit/framework/security/model/update-password-otp-type.enum.model";
import {BaseService} from "@ui-kit/framework/common/base.service";
import {PasswordUpdate} from "@ui-kit/framework/security/model/password-update.model";
import {VerifyOTPRequest} from "@ui-kit/framework/security/model/user.model";

@Injectable({
  providedIn: 'root'
})
export class UpdatePasswordService extends BaseService {
  private readonly baseUrl: string;
  private readonly baseUserUrl: string;
  private currentContext: UpdatePasswordContextModel;

  constructor(private http: HttpClient, config: AppConfigService) {
    super();
    const env = config.environment;
    this.baseUrl = env.apiSecurityHost + '/api/user/security/password';
    this.baseUserUrl = env.apiSecurityHost + '/api/user';
    this.clearContext();
    this.currentContext = UpdatePasswordContextModel.getEmptyContext();
  }

  public clearContext() {
    this.currentContext = UpdatePasswordContextModel.getEmptyContext();
  }

  public setContext(value: any) {
    this.currentContext = value;
  }


  /**
   * Update the user's password as the final step to the forgot password or update password flow
   *
   * Note: the payload is built automatically from the update password context that must be set before this service is called.
   * The fields required to do an update are: otp, secret, confirmSecret, [userId | email]
   */
  public updatePassword(): Observable<any> {
    const update = new PasswordUpdate({
      otp: this.currentContext?.otp,
      otpType: this.currentContext?.updateType,
      secret: this.currentContext?.secret,
      secretConfirm: this.currentContext?.confirmSecret,
      user: {
        email: this.currentContext?.email ? this.currentContext.email : null,
        userId: this.currentContext?.userId ? this.currentContext.userId : null
      },
    });

    // if (!update.user || !update.user.userId)
    return this.http.post(this.baseUrl, update, this.options);
  }

  public updateContextSecrets(secret: string, confirmSecret: string) {
    this.currentContext.secret = secret;
    this.currentContext.confirmSecret = confirmSecret;
  }

  public passwordInvalid(passwordResetForm: FormGroup): boolean {
    const secret = passwordResetForm.value.password;
    const confirmSecret = passwordResetForm.value.confirmPassword;

    if ((secret.length < 8)
      || !/[A-Z]+/g.test(secret)
      || !/[a-z]+/g.test(secret)
      || !/[0-9]+/g.test(secret)
      || !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(secret)
    ) {
      passwordResetForm.controls['password'].setErrors({'not-valid': true});
      passwordResetForm.get('confirmPassword')!.setValue(null);
      passwordResetForm.controls['confirmPassword'].setErrors(null);
      return true;
    }

    if (secret !== confirmSecret) {
      passwordResetForm.get('confirmPassword')!.setValue(null);
      passwordResetForm.controls['confirmPassword'].setErrors({'no-match': true});
      return true;
    }

    return false;
  }

  newPasswordRestContext(secret: string, confirmSecret: string, email: string, userId: number): void {
    this.currentContext.secret = secret;
    this.currentContext.confirmSecret = confirmSecret;
    this.currentContext.email = email;
    this.currentContext.userId = userId;
    this.currentContext.updateType = UPDATE_PASSWORD_OTP_TYPE.UPDATE_PASSWORD;
    this.currentContext.otp = null;
  }

  public verifyNewUserAccount(request: VerifyOTPRequest): Observable<any> {
    const uri = this.baseUserUrl + '/verify';
    return this.http.post(uri, request, {
      observe: 'response',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }


}
